import { render, staticRenderFns } from "./PresentingRightPlanLabel.vue?vue&type=template&id=299b8588&scoped=true&"
import script from "./PresentingRightPlanLabel.vue?vue&type=script&lang=js&"
export * from "./PresentingRightPlanLabel.vue?vue&type=script&lang=js&"
import style0 from "./PresentingRightPlanLabel.vue?vue&type=style&index=0&id=299b8588&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299b8588",
  null
  
)

export default component.exports